<script setup>
import GlobalConfirmDialog from '@/components/core/dialogs/GlobalConfirmDialog.vue';
import ToastPopups from '@/components/core/dialogs/ToastPopups.vue';
import SharedMessagePopup from '@/components/SharedMessagePopup.vue';
</script>

<template>
  <div>
    <ToastPopups />
    <SharedMessagePopup />
    <GlobalConfirmDialog />
  </div>
</template>
